import React from 'react';
import { Music, Clock, DollarSign, CheckCircle, Target, BarChart2, Printer } from 'lucide-react';
export function WhyItWorksSection() {
  return <section className="w-full bg-gradient-to-br from-orange-500 to-orange-600 py-12 md:py-20 px-4" data-id="element-406">
      <div className="max-w-4xl mx-auto" data-id="element-407">
        {/* Title */}
        <div className="text-center mb-10 md:mb-14" data-id="element-408">
          <h2 className="font-nunito font-black text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-409">
            POR QUÉ FUNCIONA
            <span className="text-yellow-300" data-id="element-410"> REALMENTE</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-411">
            <div className="h-1 w-16 bg-white/50 rounded-full" data-id="element-412" />
            <Music className="w-6 h-6 text-white/80" data-id="element-413" />
            <div className="h-1 w-16 bg-white/50 rounded-full" data-id="element-414" />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-14" data-id="element-415">
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-5 md:p-6 text-center border border-white/30" data-id="element-416">
            <p className="font-nunito font-black text-white text-4xl md:text-5xl" data-id="element-417">
              369K
            </p>
            <p className="text-white/90 font-semibold mt-2 text-sm md:text-base" data-id="element-418">
              maestros de primaria en México enfrentan tu mismo problema
            </p>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-5 md:p-6 text-center border border-white/30" data-id="element-419">
            <p className="font-nunito font-black text-white text-4xl md:text-5xl" data-id="element-420">
              75%
            </p>
            <p className="text-white/90 font-semibold mt-2 text-sm md:text-base" data-id="element-421">
              de maestros dicen: "No me siento seguro con música"
            </p>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-5 md:p-6 text-center border border-white/30" data-id="element-422">
            <p className="font-nunito font-black text-white text-4xl md:text-5xl" data-id="element-423">
              60%
            </p>
            <p className="text-white/90 font-semibold mt-2 text-sm md:text-base" data-id="element-424">
              invierte 2+ horas buscando UNA actividad decente
            </p>
          </div>
        </div>

        {/* Benefits */}
        <div className="bg-white rounded-3xl p-6 md:p-10" data-id="element-425">
          <h3 className="font-nunito font-black text-gray-900 text-xl md:text-3xl text-center mb-6 md:mb-8" data-id="element-426">
            Este eBook lo soluciona TODO:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-id="element-427">
            <div className="flex items-start gap-4" data-id="element-428">
              <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center flex-shrink-0" data-id="element-429">
                <Clock className="w-5 h-5 text-orange-600" data-id="element-430" />
              </div>
              <div data-id="element-431">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-432">
                  AHORRAS 80+ HORAS
                </p>
                <p className="text-gray-600 text-sm" data-id="element-433">
                  2h/semana x 40 semanas = tiempo libre para ti
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-434">
              <div className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-435">
                <DollarSign className="w-5 h-5 text-green-600" data-id="element-436" />
              </div>
              <div data-id="element-437">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-438">
                  SIN GASTAR en materiales caros
                </p>
                <p className="text-gray-600 text-sm" data-id="element-439">
                  Solo materiales caseros que ya tienes
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-440">
              <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center flex-shrink-0" data-id="element-441">
                <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-442" />
              </div>
              <div data-id="element-443">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-444">
                  CUMPLE SEP 100%
                </p>
                <p className="text-gray-600 text-sm" data-id="element-445">
                  Objetivos oficiales incluidos en cada plan
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-446">
              <div className="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-447">
                <Target className="w-5 h-5 text-purple-600" data-id="element-448" />
              </div>
              <div data-id="element-449">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-450">
                  ALUMNOS PARTICIPAN
                </p>
                <p className="text-gray-600 text-sm" data-id="element-451">
                  Porque es DIVERTIDO y culturalmente relevante
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-452">
              <div className="w-10 h-10 rounded-xl bg-yellow-100 flex items-center justify-center flex-shrink-0" data-id="element-453">
                <BarChart2 className="w-5 h-5 text-yellow-600" data-id="element-454" />
              </div>
              <div data-id="element-455">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-456">
                  EVALUACIONES CLARAS
                </p>
                <p className="text-gray-600 text-sm" data-id="element-457">
                  Rúbricas listas para imprimir, sin inventar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-458">
              <div className="w-10 h-10 rounded-xl bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-459">
                <Printer className="w-5 h-5 text-red-600" data-id="element-460" />
              </div>
              <div data-id="element-461">
                <p className="font-nunito font-black text-gray-900 text-lg" data-id="element-462">
                  IMPRIME LO QUE NECESITES
                </p>
                <p className="text-gray-600 text-sm" data-id="element-463">
                  1 solo PDF, sin complicaciones ni links externos
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}